import React from 'react'

import classNames from 'classnames'
import { AppGroup } from 'shared/constants/apps'
import { AppConfig } from 'shared/types/app'

import { getGroupLabel } from '../../LaunchPad.utils'

export interface GroupSectionProps {
  groupKey: AppGroup
  apps: AppConfig[]
  children: React.ReactNode
  className?: string
  styles?: {
    groupSection?: string
    groupHeader?: string
    groupTitle?: string
    lockedGroupTitle?: string
    groupProLabel?: string
    appsGrid?: string
  }
}

export const GroupSection: React.FC<GroupSectionProps> = ({
  groupKey,
  apps,
  children,
  className,
  styles: componentStyles
}) => {
  if (!apps || apps.length === 0) return null

  if (!componentStyles) {
    // Fallback if styles not provided
    return null
  }

  return (
    <div
      key={groupKey}
      className={classNames(componentStyles.groupSection, className)}
      data-tour={groupKey}
    >
      <div className={componentStyles.groupHeader}>
        <h3 className={componentStyles.groupTitle}>
          {getGroupLabel(groupKey)}
        </h3>
      </div>
      <div className={componentStyles.appsGrid}>{children}</div>
    </div>
  )
}
